import React from 'react';
import { H2, H3, IconCheck, IconXMark, NamedLink } from '../../../components';

import css from './SectionQuote.module.css';
import classNames from 'classnames';

const items = [
  {
    icon: <IconCheck className={css.iconCheck} />,
    title: 'HowItWorksPage.quote.priceIncludesTitle',
    textList: [
      {
        caption: 'HowItWorksPage.quote.performanceFeeCaption',
        text: 'HowItWorksPage.quote.performanceFeeText',
      },
      {
        caption: 'HowItWorksPage.quote.travelExpensesCaption',
        text: 'HowItWorksPage.quote.travelExpensesText',
      },
      {
        caption: 'HowItWorksPage.quote.layoverFeesCaption',
        text: 'HowItWorksPage.quote.layoverFeesText',
      },
    ],
  },
  {
    icon: <IconXMark className={css.iconX} />,
    title: 'HowItWorksPage.quote.priceDoesntIncludeTitle',
    textList: [
      {
        caption: 'HowItWorksPage.quote.overnightAccomodationCaption',
        text: 'HowItWorksPage.quote.overnightAccomodationText',
      },
      {
        caption: 'HowItWorksPage.quote.extraCostsCaption',
        text: 'HowItWorksPage.quote.extraCostsText',
      },
      {
        text: 'HowItWorksPage.quote.terms',
      },
    ],
  },
];

const SectionQuote = props => {
  const { intl, className, titleClassName } = props;
  return (
    <div className={classNames(css.root, className)} id="quote_includes">
      <H2 className={titleClassName}>
        {intl.formatMessage(
          { id: 'HowItWorksPage.quote.heading' },
          { span: text => <span className={css.marketplaceText}>{text}</span> }
        )}
      </H2>
      <div className={css.cardsWrapper}>
        {items.map(item => (
          <div className={css.card} key={item.title}>
            {item.icon}
            <H3 className={css.h3}>{intl.formatMessage({ id: item.title })}</H3>
            <ul className={css.textList}>
              {item.textList.map(textItem => (
                <li className={css.text} key={textItem.text}>
                  {textItem.caption && (
                    <span className={css.bold}>{intl.formatMessage({ id: textItem.caption })}</span>
                  )}
                  {intl.formatMessage(
                    { id: textItem.text },
                    {
                      link: text => <NamedLink name="TermsOfServicePage">{text}</NamedLink>,
                    }
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionQuote;
